var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRulesUsp3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_548_9)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 32,
    r: 32,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_548_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0419 17.8369C34.3005 18.7032 34.9655 19.1363 35.9631 19.1724C36.9975 19.1724 37.6626 18.7753 37.9581 17.8369C43.8325 18.3783 50.2611 23.3953 50.9261 31.0471C51.665 39.4208 45.1626 46.5673 36.7389 46.9643C28.1305 47.3974 21 40.7201 21 32.3465C21 24.1894 27.5394 18.5227 34.0419 17.8369ZM36.0369 20.6522C29.4236 20.6522 24.0665 25.8497 24.0665 32.3104C24.0665 38.7711 29.3867 44.0046 36 44.0407C42.5764 44.0407 47.9335 38.8433 47.9704 32.3465C47.9704 25.9218 42.6133 20.6522 36.0369 20.6522Z",
    fill: "#A48242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1104 15.5626C35.2976 15.5626 34.4478 15.5626 33.635 15.5626C33.0069 15.5626 32.6744 15.2378 32.6744 14.5881C32.6744 14.3355 32.6744 14.0828 32.6744 13.8301C32.6375 13.3609 33.0069 13 33.4872 13C35.2237 13 36.9971 13 38.7335 13C39.2138 13 39.5463 13.3609 39.5833 13.7941C39.6202 14.0828 39.6202 14.4076 39.5833 14.6964C39.5463 15.2017 39.1769 15.5265 38.6596 15.5265C37.8099 15.5626 36.9601 15.5626 36.1104 15.5626Z",
    fill: "#A48242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0376 15.9961C36.3331 15.9961 36.6656 15.9961 36.9612 15.9961C37.109 15.9961 37.2198 16.0322 37.1829 16.2127C37.1829 16.718 37.1829 17.2233 37.1829 17.7286C37.1829 18.0534 36.9982 18.3061 36.6657 18.4144C36.2223 18.5948 35.779 18.5948 35.3725 18.4504C35.0031 18.3422 34.8184 18.0534 34.8184 17.6925C34.8184 17.1872 34.8184 16.718 34.8184 16.2127C34.8184 16.0322 34.8923 15.9961 35.04 15.9961C35.3725 15.9961 35.7051 15.9961 36.0376 15.9961Z",
    fill: "#A48242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7775 22.998C35.9992 22.998 36.2209 22.998 36.4425 22.998C36.4425 23.1063 36.4425 23.2146 36.4425 23.3229C36.4425 25.8133 36.4425 28.3038 36.4425 30.7942C36.4425 30.9747 36.4795 31.083 36.7012 31.1552C37.4031 31.4439 37.7726 32.1297 37.6248 32.8155C37.477 33.5373 36.8859 34.0065 36.147 34.0065C35.445 34.0065 34.8169 33.5012 34.6691 32.8516C34.5214 32.1297 34.8539 31.4439 35.5928 31.1552C35.8145 31.083 35.8514 30.9747 35.8514 30.7581C35.8514 28.2677 35.8514 25.7772 35.8514 23.3229C35.7775 23.2507 35.7775 23.1424 35.7775 22.998Z",
    fill: "#A48242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4018 31.2638C38.2171 30.8306 37.9215 30.4336 37.4043 30.2892C38.291 29.4591 39.1408 28.5928 39.9905 27.7627C40.2861 28.0875 40.6555 28.4124 40.988 28.7372C40.1383 29.6035 39.2885 30.4336 38.4018 31.2638Z",
    fill: "#A48242"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_548_9",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_548_9"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_548_9",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_548_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 34,
    fill: "white",
    transform: "translate(21 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRulesUsp3);
export default __webpack_public_path__ + "static/media/rules-usp3.c50bd1e04c282d5c368800960f9288dc.svg";
export { ForwardRef as ReactComponent };